module.exports = __webpack_public_path__ + "img/74.b0c3de31.jpg";